import axios, { AxiosResponse } from "axios";
import { TableData } from "../../models/dtos/base/TableData";
import { UserReferrerDTO } from "../../models/dtos/management/UserReferrerDTO";
import { UserReferrerEditionDTO } from "../../models/dtos/management/UserReferrerEditionDTO";
import { QueryPagesDTO } from "../../models/query-strings/base/QueryPagesDTO";
import BaseService from "../base/BaseService";

export default class UserReferrerService extends BaseService {
    getPages(queryInfo: QueryPagesDTO): Promise<TableData<UserReferrerDTO>> {
        return axios.get(`/UserReferrer`, { params: queryInfo })
            .then(function (response: AxiosResponse<TableData<UserReferrerDTO>, any>) {
                return response.data;
            });
    }

    sendInvitation(dto: UserReferrerEditionDTO): Promise<any> {
        return axios.post(`/UserReferrer`, dto)
            .then(function (response: AxiosResponse<any, any>) {
                return response;
            });
    }

}